import { render, staticRenderFns } from "./ChapterModalAdd.vue?vue&type=template&id=aba490c8&scoped=true&lang=pug"
import script from "./ChapterModalAdd.vue?vue&type=script&lang=js"
export * from "./ChapterModalAdd.vue?vue&type=script&lang=js"
import style0 from "./ChapterModalAdd.vue?vue&type=style&index=0&id=aba490c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba490c8",
  null
  
)

export default component.exports